import React, { Component } from "react";
import Form from "../components/Form/Form";
import templates from "../components/FormTemplates";
import { connect } from "react-redux";
import dynamicPortal from "../utils/dynamicPortal";
import stopActions from "../actions/stop";
import dienstregelingActions from "../actions/dienstregeling";
import connection from "../api/config/connection";
export class HalteFormPortal extends Component {
  constructor() {
    super();
    this.formRef = React.createRef();
  }

  render() {
    return dynamicPortal.load(".js-react-halte-form", (config) => {
      config.submit.method = "GET";
      config.submit.async = true;

      return (
        <div className="theme--accent">
          <div className="container container--center container--clearfix">
            <div className="container container--margin">
              <Form
                ref={this.formRef}
                config={config}
                templates={templates}
                axios={connection.instance()}
                onSubmit={(values, config) => this.handleSubmit(values, config)}
                onError={(error) => this.handleError(error)}
              />
            </div>
          </div>
        </div>
      );
    });
  }

  handleSubmit(values, config) {
    this.props.setRequestValues(values, config.submit.action);
    this.props.onClickRefresh((result) => {
      var routeIds = result.routes.map((route) => route.route_id);
      this.props.requestStopDisruptions(
        config.disruptionsUrl,
        config.agencyId,
        routeIds
      );
    });
  }

  handleError() {
    this.props.failedStop();
  }
}

export default connect(
  (state) => ({ stop: state.stop }),
  (dispatch) => {
    return {
      failedStop: (error) => dispatch(stopActions.failed(error)),
      onClickRefresh: (callback) =>
        dispatch(stopActions.onClickRefresh(callback)),
      setRequestValues: (values, url) =>
        dispatch(stopActions.setRequestValues(values, url)),
      requestStopDisruptions: (url, agencyId, routeIds) =>
        dispatch(
          dienstregelingActions.requestStopDisruptions(url, agencyId, routeIds)
        ),
    };
  }
)(HalteFormPortal);



// WEBPACK FOOTER //
// ./src/portals/HalteFormPortal.js